export default (theme) => ({
  avatarColor: {
    backgroundColor: theme.color.black,
  },
  listItem: {
    '-webkit-tap-highlight-color': 'transparent',
    cursor: 'pointer',
    alignItems: 'flex-start',
    maxHeight: 72,
  },
  avatarRoot: {
    marginTop: theme.spacing(1),
    position: 'relative',
    zIndex: 1,
  },
  name: {
    '& .MuiListItemText-primary': {
      position: 'relative',
      zIndex: 1,
    },
  },
  nameHidden: {
    height: 72,
    lineHeight: '0.5rem',
    overflow: 'hidden',
    margin: 0,
    '& .MuiListItemText-primary': {
      position: 'relative',
      zIndex: 1,
      fontSize: '0.5rem',
      transition: 'font-size .1s linear',
    },
  },
  title: {
    fontSize: '16px',
    textTransform: 'uppercase',
    fontWeight: 'normal',
    color: theme.color.grey_55,
  },
  stanleyIconsWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
  },
});
